import { Button, Icon } from "Components";
import Icons from "Components/Icon/Icons";

type AlertProps = {
    title?: string,
    subtitle: string,
    btnText?: string | null,
    iconType?: keyof typeof Icons;
    btnClick?: () => void
}

const Alert = ({ title = '', subtitle, btnText = '', iconType = 'campaignInfo', btnClick }: AlertProps) => <div className="pm-info-banner">
    <div className="pm-info-row">
        <div className="pm-info-icon">
            <Icon type={iconType} />
        </div>

        <div className="pm-info-group">
            <div className="pm-info-text-group">
                {title && <div className="pm-info-title">
                    <strong>{title}</strong>
                </div>}
                <div className="pm-info-description">
                    {subtitle}</div>
            </div>
            {btnText && <Button shape="round" type="primary" onClick={btnClick}>{btnText}</Button>}
        </div>
    </div>

</div>

export default Alert;